class BikeParkingLayer extends Layer {

  constructor(mapGL, isVisible = false) {
    super(mapGL, isVisible);

    this.name = 'bikeparking';
    this.minZoom = 10;
    this.layerIds = ['bikeparking'];

    this.isClickable = true;

    this.load();
  }

  load() {

    this.mapGL.getMapObject().addSource(this.name + '-source', {
      'type': 'geojson',
      'data': CACHE_URL + '/getLayer?action=load&layer=bikeParking'
    });

    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[0],
      'type': 'symbol',
      'source': this.name + '-source',
      'layout': {
        'icon-image': this.name,
        'icon-allow-overlap': true,
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });

    var thisLayer = this;

    this.mapGL.getMapObject().on('click', this.layerIds[0], function (e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var popupContent = thisLayer.getPopupContent(e.features[0]);

      if (thisLayer.mapGL.popup.isOpen()) {
        thisLayer.mapGL.popup.remove();
      }

      thisLayer.mapGL.popup = new maplibregl.Popup({focusAfterOpen: false})
        .setLngLat(coordinates)
        .setHTML(popupContent)
        .setMaxWidth("none")
        .addTo(thisLayer.mapGL.getMapObject());
    });

    if (!Utils.isMobileOrTablet()) {
      this.mapGL.getMapObject().on('mouseenter', this.layerIds[0], function (e) {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);

        if (thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.remove();
        }

        thisLayer.mapGL.tooltip.setLngLat(coordinates)
          .setHTML(tooltipContent)
          .addTo(thisLayer.mapGL.getMapObject());
      });

      this.mapGL.getMapObject().on('mousemove', this.layerIds[0], function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);
        thisLayer.mapGL.tooltip.setLngLat(coordinates).setHTML(tooltipContent);
        if (!thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.addTo(thisLayer.mapGL.getMapObject());
        }
      });

      this.mapGL.getMapObject().on('mouseleave', this.layerIds[0], function () {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
        thisLayer.mapGL.tooltip.remove();
      });
    }
  }

  getTooltipContent(feature) {
    var tooltipContent = '<div class="map-tooltip">' + feature.properties.nom + '</div>';
    return tooltipContent;
  }

  getPopupContent(feature) {

    var hasLogo = true;
    var logoImageFile;
    var linkUrl;
    var linkTitle;

    switch (feature.properties.gestionnaire) {

      case 'SYTRAL':
        logoImageFile = 'logo-sytral.png';
        linkUrl = 'https://www.tcl.fr/services/parcs-relais-velo';
        linkTitle = 'Accéder au site TCL (nouvelle fenêtre)';
        break;

      case 'SNCF':
        logoImageFile = 'logo-sncf-ter-rhone-alpes.png';
        linkUrl = 'https://www.ter.sncf.com/auvergne-rhone-alpes/services-contacts/voyager-avec-velo/stationnement-gare';
        linkTitle = 'Accéder au site SNCF TER Auvergne-Rhône-Alpes (nouvelle fenêtre)';
        break;

      case 'Lyon Parc Auto':
        logoImageFile = 'logo-lpa.png';
        linkUrl = 'https://www.lpa.fr/des-solutions-pour-stationner-son-velo-en-parc-et-en-voirie/';
        linkTitle = 'Accéder au site Lyon Parc Auto (nouvelle fenêtre)';
        break;

      default:
        hasLogo = false;
        break;
    }

    //svp DOS0302524
    //https://data.grandlyon.com/geoserver/metropole-de-lyon/ows?SERVICE=WFS&VERSION=2.0.0&request=GetFeature&typename=metropole-de-lyon:pvo_patrimoine_voirie.pvostationnementvelo&outputFormat=application/json&SRSNAME=EPSG:4171&startIndex=0&sortBy=gid
    if (feature.properties.identifiant) {
      switch (feature.properties.identifiant) {

        case '2210':
          logoImageFile = 'logo-confluence.png';
          linkUrl = 'https://www.westfield.com/france/confluence/services-detail/parking-%C3%A0-v%C3%A9los-et-trottinettes-';
          linkTitle = 'Accéder au site Westfield (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case '3048':
          logoImageFile = 'logo-partdieu.png';
          linkUrl = 'https://www.westfield.com/france/lapartdieu/services-detail/parking-v%C3%A9lo';
          linkTitle = 'Accéder au site Westfield (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case '3661':
          logoImageFile = 'logo-partdieu.png';
          linkUrl = 'https://www.westfield.com/france/lapartdieu/services-detail/parking-v%C3%A9lo';
          linkTitle = 'Accéder au site Westfield (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case 'ECU50':
          logoImageFile = 'logo-ecully.png';
          linkUrl = 'https://www.ecully.fr/actualites-109/des-box-securises-pour-les-velos-4270.html';
          linkTitle = 'Accéder au site de la mairie d\'Ecully (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case 'BRO96':
          logoImageFile = 'logo-bron.png';
          linkUrl = 'https://www.ville-bron.fr/ma-ville-au-quotidien/se-deplacer/velo/les-box-velos';
          linkTitle = 'Accéder au site de la mairie de Bron (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case 'TDL14':
          logoImageFile = 'logo-tdl.png';
          linkUrl = 'https://www.tassinlademilune.fr/accueil/actualites/un-parc-a-velo-a-tester-derriere-latrium';
          linkTitle = 'Accéder au site de la mairie de Tassin-la-Demi-Lune (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case '3667':
          logoImageFile = 'logo-effia.png';
          linkUrl = 'https://www.effia.com/parking/parking-gare-de-lyon-part-dieu-villette-effia';
          linkTitle = 'Accéder au site EFFIA (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case '3178':
          logoImageFile = 'logo-toodego.png';
          linkUrl = 'https://demarches.toodego.com/mobilite/acceder-au-parc-velov-villette-part-dieu/';
          linkTitle = 'Accéder au site Toodego (nouvelle fenêtre)';
          hasLogo = true;
          break;

        case '3759':
          logoImageFile = 'logo-lpa-co.png';
          linkUrl = 'https://www.lpa-and-co.fr/parkings/part-dieu-deruelle/';
          linkTitle = 'Accéder au site Lyon Parc Auto (nouvelle fenêtre)';
          hasLogo = true;
          break;

        default:
          break;
      }
    }

    var popupContent = '<div class="map-popup">';
    popupContent += '<img class="map-popup__icon" src="' + IMG_PATH + '/Unsprited/mapicons/' + feature.layer.layout["icon-image"] + '.svg" alt="" aria-hidden="true">';

    if (feature.properties.nom !== null) {
      popupContent += '<span class="map-popup__title">' + feature.properties.nom + '</span>';
      popupContent += '<hr>';
    }

    if (feature.properties.adresse !== null) {
      popupContent += '<p>' + feature.properties.adresse + '</p>';
    }

    if (feature.properties.capacite !== null) {
      var capacityLabel = 'Non communiqué';

      if (feature.properties.capacite > 0) {
        capacityLabel = feature.properties.capacite + ' place';
        if (feature.properties.capacite > 1) {
          capacityLabel = capacityLabel + 's';
        }
      }

      popupContent += '<p>';
      popupContent += '<span class="map-popup__capacity">Capacité vélos : <b>' + capacityLabel + '</b></span>';
      popupContent += '<br>';
      popupContent += '</p>';
    }

    if (hasLogo){
      popupContent += '<a href="' + linkUrl + '" title="' + linkTitle + '" target="_blank">' +
        '<img src="/typo3conf/ext/gl_portailvelo_maps/Resources/Public/Images/parking/' + logoImageFile + '" alt="" />' +
        '</a>';
    }

    popupContent += JourneyPlanner.getPopupContentActions(feature._geometry.coordinates, feature.properties.nom);
    popupContent += '</div>';

    return popupContent;
  }
}
